var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"NextButton",on:{"click":function($event){return _vm.nextQuestion()}}},[_vm._v("\n    "+_vm._s(( _vm.next == "results" ? "Results" : "Next" ))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }